import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'
import { SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  wrapperAbsolute: {
    '&&': {
      position: 'absolute',
    },
  },
  wrapperFixed: {
    '&&': {
      position: 'fixed',
    },
  },
  bottomLayoutWrapper: {
    '&&': {
      bottom: 0,
      right: 0,

      paddingTop: SPACES.xxl,
      paddingBottom: '22px',
      paddingLeft: SPACES.xxl,
      paddingRight: '80px',

      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      rowGap: SPACES.l,
      flexWrap: 'nowrap',
      width: '100%',

      backgroundColor: theme.palette.custom.white,
      zIndex: 100,

      '&:empty': {
        display: 'none',
      },
    },
  },
}))

export default useStyles
